// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--K3PG7","header":"header--Fzc5u","body":"body--KWUut"};